/**
 * Icon contract for Harness — @see features/20260602-trackers-setup-onboarding-modal/ICON_AUDIT.md
 */
export const TRACKERS_SETUP_GOAL_SVG_NAME = "goal-16-portfolio" as const;

export const OSP_ICON_CODEPOINT = {
  ed: 60179,
};

export const TRACKERS_SETUP_ICON_SPEC = {
  ed: {
    testId: "trackers-setup-ed-icon",
    chipTestId: "trackers-setup-ed-chip",
    figmaNodes: ["87676:37505", "88125:5707"],
    ospName: "ed",
    codepoint: OSP_ICON_CODEPOINT.ed,
    sizePx: 20,
    chipSizePx: 32,
  },
  goal: {
    testId: "trackers-setup-goal-icon",
    figmaNodes: ["87676:37458", "88100:38128"],
    ospName: TRACKERS_SETUP_GOAL_SVG_NAME,
    sizePx: 16,
    chipSizePx: 32,
    forbiddenOspNames: [] as string[],
  },
};
